import React from "react";
import { EVM_CONFIG } from "../../config";
import { formatDisplayUnits } from "../helpers/amountDisplay";
import type { NativeDepositMaxQuote } from "../../joinsplit-v2/depositMax";
import { usesPrivateFees } from "../../joinsplit-v2/privateFees";

export function BaseDepositEstimate({
  quote,
  estimating,
  error,
}: {
  quote: NativeDepositMaxQuote | null;
  estimating?: boolean;
  error?: string;
}) {
  const symbol = EVM_CONFIG.CHAIN_ID === 6281971 ? "DOGE" : "ETH";
  return (
    <div
      style={{
        fontSize: "13px",
        color: "#b0c4de",
        marginTop: "10px",
        overflowWrap: "anywhere",
      }}
      aria-live="polite"
    >
      {estimating && <p>Estimating deposit network fee…</p>}
      {error && <p role="alert">{error}</p>}
      {quote && (
        <>
          <div>
            Wallet balance: {formatDisplayUnits(quote.balance, 18)} {symbol}
          </div>
          {!usesPrivateFees() && (
            <div>
              Protocol fee: {formatDisplayUnits(quote.protocolFee, 18, "up")}{" "}
              {symbol}
            </div>
          )}
          <div>
            Estimated network fee (conservative):{" "}
            {formatDisplayUnits(quote.networkFee, 18, "up")} {symbol}
          </div>
          <div style={{ color: "#f0f4ff", marginTop: "6px" }}>
            {usesPrivateFees() ? "Deposit before fees" : "Amount to deposit"}:{" "}
            {formatDisplayUnits(quote.amount, 18)} {symbol}
          </div>
          <p style={{ marginBottom: 0 }}>Unused gas stays in your wallet.</p>
        </>
      )}
    </div>
  );
}
